export interface ResponseWithSignals {
  $signals: string[] | undefined;
  $signals_data: SignalData[] | undefined;
}

export enum Signal {
  FreeSubAvailable = 'FreeSubAvailable',
  TriggeredFreeSub = 'TriggeredFreeSub',
  UserLevelNowContributor = 'UserLevelNowContributor',
  UserLevelSharer = 'UserLevelSharer', // @deprecated
  UserIsNowSuper = 'UserIsNowSuper',
  Dragon2024 = 'Dragon2024',
  UpdatedSearchDistance = 'UpdatedSearchDistance', // @deprecated
  NeedAppUpdate = 'NeedAppUpdate',
  PostalCodeTooLarge = 'PostalCodeTooLarge',
  CustomPopup = 'CustomPopup',
  WarningCodeIsFull = 'WarningCodeIsFull',
}

export type SignalData = object;

export interface UserLevelSharerSignalData extends SignalData {
  level: string;
  numLoans: number;
}

export interface FreeSubSignalData extends SignalData {
  program: 'defricheur' | 'trial';
  numDaysLeft?: number;
  numOffers?: number;
}

export interface WarningCodeIsFullData extends SignalData {
  name: string;
}

export interface UpdatedSearchDistanceSignalData extends SignalData {
  distance: number;
}

export function hasSignal(response: ResponseWithSignals | undefined, signal: Signal): boolean {
  return Boolean(response?.$signals?.includes(signal));
}

export function getSignalData(response: ResponseWithSignals | undefined, signal: Signal): SignalData | undefined {
  if (!response?.$signals) {
    return;
  }
  const pos = response.$signals.indexOf(signal);
  if (pos === -1) {
    return;
  }
  return response.$signals_data?.[pos];
}
